import React, { FunctionComponent, useEffect, useRef } from 'react'
import { useMutation } from '@apollo/client'
import { USE_AUTO_LINK } from '@/modules/API/software/autoLinkHandler'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import { Browser } from '@capacitor/browser'
import { USE_STAFF_AUTO_LINK } from '@/modules/API/software/staffAutoLinkHandler'
import { Role } from '@/types/Role'
import MainLoading from '../other/mainLoading'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { useTranslation } from 'react-i18next'

interface AutoLinkProps {
    autoLink: string
    role?: Role
}

const UseAutoLinkLogged: FunctionComponent<AutoLinkProps> = ({ autoLink, role }) => {
    const navigate: NavigateFunction = useNavigate()
    const { t } = useTranslation()
    const { showNotificationError } = useNotification()

    const [autoLinkMutation] = useMutation(USE_AUTO_LINK, {
        onCompleted: async (dataAutoLink) => {
            removeServiceWorker()
            await Browser.open({
                url: '/daycare?daycare=' + dataAutoLink.useAutoLink,
                windowName: '_self'
            })
        },
        onError: () => {
            showNotificationError(t('autoLinkError'))
            navigate('/')
        }
    })

    const [autoLinkStaffMutation] = useMutation(USE_STAFF_AUTO_LINK, {
        onCompleted: async (dataAutoLink) => {
            removeServiceWorker()
            await Browser.open({
                url: '/daycare?daycare=' + dataAutoLink.useStaffAutoLink,
                windowName: '_self'
            })
        },
        onError: () => {
            showNotificationError(t('autoLinkError'))
            navigate('/')
        }
    })

    const autoLinkRef: React.MutableRefObject<string | undefined> = useRef(autoLink)
    const roleRef: React.MutableRefObject<Role | undefined> = useRef(role)

    useEffect(() => {
        if (autoLinkRef.current && roleRef.current) {
            if (roleRef.current === Role.parent) {
                autoLinkMutation({ variables: { autoLink: autoLinkRef.current } })
            } else {
                autoLinkStaffMutation({ variables: { autoLink: autoLinkRef.current } })
            }
        }
    }, [autoLinkMutation, autoLinkStaffMutation])

    return <MainLoading />
}

export default UseAutoLinkLogged
